<template>
  <div>
	<lighthouse  @objectClick="objectClick" @showWreckGui="showWreckGui" :videoShowing="videoShowing" :screenVis="screenVis"></lighthouse>

	<div @showScreen="showScreen" class="gui"  ref="GUI" :style="'top:'+screenTop()+'px;'">
	<Wrecks @closePanel="closePanel" :scSize="scSize"></Wrecks>
	 
	</div>
	 <div  v-if="showHelpIcon" style="top: 20px;right: 10px;opacity:.7;background-color:#160f2b00;" class="helpIcon" @click="showHelpClick"></div>
    
	<div class="beams" ref="beams"></div>
	<div class="projector"  :style="'top:'+projectorTop+'px;width:'+projectorWidth+'px;height:'+projectorHeight+'px;padding-top:10px;'">
		<video  @click="pauseVideo"  ref="previewVid" playsinline autoplay
			:style="'opacity:'+vidOpacity" width="99%" type="video/mp4" 
				:src="vidSrc" >	</video>
				
		<div class="CTA" ref="CTA"> 
			<div v-if="isCut">
				<div @click="closeVideo" class="closeCut">Close Video</div>
				<div class="vidMessage">Click the wall switch in the lighthouse to view the story so far.</div>
			</div>
			<div v-else>
			<h2>Research and discover the wreck to unlock the full story</h2>
			<button @click="showScreen">Examine the Evidence</button>
			<button @click="replayVideoSequence">Replay Video</button>
			<button @click="closeVideo">Explore other Artefacts</button>
			</div>
			
		</div>
		<div @click="stopNcloseVideo" class="closeBtn" style="font-size:20px;opacity:0.7;margin: 5px;">[x]</div>
	</div>
  </div>
</template>

<script>
import notification from '@/components/notification'
import Help from '@/mixins/help'
import gsap from "gsap";
import screen from "@/mixins/screen"
import lighthouse from '@/components/Lighthouse'
import Wrecks from '@/components/panels/Wrecks'


var self
export default {
   	components: {
		  lighthouse,
		   Wrecks,
		   notification
	   },
	   mixins:[screen,Help],
		data: () => ({
			vidSrc:null,
			videoPlaying:false,
			screenY:0,
			isCut:false,
			projectorTop:-1000,
			vidOpacity:0,
			wreckName:null,
			vid:null,
			screenVis:false,
			enablePause:false,
			//help1:{name:"stuff",help:{}},
			welcomePlayed:false,
			videoShowing:false,
			lightHouseHelps:[6,7],
			lightHelpIndex:1,
			scSize:"unsized",
			helps:[
				{id:"H004_welcome",shown:false,help:{}},
				{id:"H005_explore",shown:false,help:{}},
				{id:"H111_ScanDocs",shown:false,help:{}},
				{id:"H112_Squares",shown:false,help:{}},
				{id:"H801_cantPlan",shown:false,help:{}},
				{id:"H802_cantExhibit",shown:false,help:{}},
				{id:"H002_lighthouse",shown:false,help:{}},
				{id:"H113_Switch",shown:false,help:{}},
				//,
				//{id:"H005_explore",showOnce:false,shown:false,help:{}
			]
			//"Welcome to the trophy room.<br>Around the wall you will find various artefacts. These are the first clues to the ship wrecks.<br>Select an artefact to start your journey."
		}),
		mounted(){
			self=this
			this.stopHelp()
			this.isCut=false;
			
			this.projectorTop=-this.projectorHeight-400
			if(this.selectedWreck){
				
				gsap.delayedCall(2,this.showScreen)
				//this.showScreen()
			}
			
			if(this.firstPlay){
				gsap.delayedCall(6,this.showFirstRunHelp)
			}
			this.$store.commit('setFirstPlay',false)
			window.onresize =this.doResize
			this.scSize=window.innerWidth
			//this.scSize.h=twindow.innerHeight
		
		},
		computed:{
			fireBaseLoc(){
				return this.$store.getters.getFireBaseLoc					
			},
			pTop(){
				return Math.floor((window.innerHeight-this.projectorHeight)*.5)
			},
			showHelpIcon(){
				return this.$store.getters.getShowHelpIcon
			},
			fireBaseWrecks(){
				return this.$store.getters.getFireBaseWrecks
			},
			isUnavailable(){
      			return this.$store.getters.getIsUnavailable
  			},
			showIntro(){
				return this.$store.getters.getShowIntro
			},
			firstPlay(){
				return this.$store.getters.getFirstPlay
			},
			 volume(){
			return this.$store.getters.getVolume
			},
			debug(){
				return this.$store.getters.getDebug
			},
			gameStatus(){
				return this.$store.getters.getGameStatus
			},
			unlockedScenes(){
				
				console.log("unlockedScenes",this.wreckStatus)
				if(this.wreckStatus){
					if(!this.wreckStatus.scenes){
						this.wreckStatus.scenes=[]
					}
					return this.wreckStatus.scenes
				}else{
					return null
				}
				
			},
			selectedWreck(){
				return this.$store.getters.getWreck
			},
			selectedWreckId(){
				if(this.selectedWreck){
					return this.selectedWreck.id
				}
				
			},
			videoElement(){
        		return this.this.$refs.previewVid
      		},
			
			
			
			cutScene(){
				return this.$store.getters.getCutScene
			},
			wreckStatus(){
				if(this.selectedWreck){
					return this.$store.getters.getWreckStatus[this.selectedWreck.id]
				}else{
					return null
				}
      		},
			projectorWidth(){
				return 1920*this.containScale(1920,1080)*.8;
			},
			projectorHeight(){
				return 1080*this.containScale(1920,1080)*.8;
			},
		},
		methods:{
		
			doResize(){
				//this.prorectorTop
				//gsap.set(".projector",{width:window.innerWidth,height:window.innerHeight})
				console.log("RESIZE")
				if(this.screenVis){
					this.screenY=this.windowHeight
				}
				this.scSize=this.windowWidth
				//this.scSize.h=this.windowHeight
				console.log("RESIZE")
				
			},
			
			screenTop(){
				return this.windowHeight-this.screenY
			},
			transTo(page,text){
        		let tText=text || "Meanwhile"
        		this.$store.dispatch('startTransition',{text:tText,to:page})
    		},
			showHelpClick(){
				console.log("SHOW HELP")
				if(!this.welcomePlayed){
					console.log("Show Welcome")
					this.showHelp()
					//this.$store.dispatch("showHelp",this.helps[0])
					this.welcomePlayed=true
				}else if(this.screenVis){
					this.showHelp()
					//alert("VIS HELP")
					
				}else{
					this.$store.dispatch("showHelp",this.helps[this.lightHouseHelps[this.lightHelpIndex]])
					this.lightHelpIndex=[this.lightHelpIndex+1]%this.lightHouseHelps.length
				}
					
				
			},
			showFirstRunHelp(){
				console.log("SHOW FIRST")
				this.$store.dispatch("showHelp",this.helps[6])
			},
			
			
			
			videoEnded(){
				console.log("VIDEO ENDED")
				gsap.killTweensOf(this)
				gsap.to(this,1,{vidOpacity:.1})
				gsap.to(this.$refs.CTA,1,{autoAlpha:1})
			},
			playVideo(src){
				this.stopHelp()
				console.log("PLAY")
				this.videoShowing=true
				this.videoPlaying=true
				gsap.killTweensOf(this)
				this.$refs.previewVid.setAttribute('crossorigin', 'anonymous');
				
				self.$refs.previewVid.currentTime=0;
				self.$refs.previewVid.onended =null
				let vid
				if(Array.isArray(src) && src.length>1){ 

					
					
					
					vid=src.shift()
					console.log("VIDEO",vid,src)
					if(vid.indexOf("http")==-1){ 
						vid=self.fireBaseWrecks+vid
					}
					self.vidSrc=vid
				
					if(src.length==1){
						src=src[0]
					}
					self.$refs.previewVid.onended = function() {
						self.playVideo(src) 
					}
				}else{
					
					console.log("SRC ARRAY",src)
					if(Array.isArray(src) && src.length==1){
						src=src[0]
						console.log("SRC",src)
					}
					if(src){
						if(src.indexOf("http")==-1){
							
							src=self.fireBaseWrecks+src
						}	
						self.vidSrc=src
					}
						console.log("VIDEO SOURCE",self.vidSrc)
						self.$refs.previewVid.onended = function() {
						self.videoEnded()
					};
					
				}
				
				this.$refs.previewVid.load()
				this.$refs.previewVid.addEventListener('canplay',this.justPlay)
				/*this.$refs.previewVid.onended = function() {
					self.videoEnded()
				};*/
				gsap.to(this,1,{projectorTop:this.pTop})
				gsap.fromTo(this,.01,{vidOpacity:.8,repeat:-1},{vidOpacity:.7})
				this.$refs.previewVid.volume=this.volume
			},
			justPlay(){
				this.enablePause=true
				console.log("CAN PLAY",this.$refs.previewVid)
				if(this.$refs.previewVid.paused){
					this.$refs.previewVid.play()
				}
				
				this.$refs.previewVid.removeEventListener('canplay',this.justPlay)
			},
			pauseVideo(){
				if(this.$refs.previewVid.paused){
					this.$refs.previewVid.play()
				}else{
				if(this.enablePause){
					console.log("pause video")
					this.$refs.previewVid.pause()
					gsap.to(this.$refs.CTA,1,{autoAlpha:1})
				}
				}

			},
			replayVideoSequence(){
				gsap.to(this.$refs.CTA,1,{autoAlpha:0})
				this.$refs.previewVid.currentTime=0;
				this.$refs.previewVid.volume=this.volume
				console.log(self.unlockedScenes,this.unlockedScenes)
				if(this.unlockedScenes && this.unlockedScenes.length>0){
					this.playVideo(this.unlockedScenes.concat())
				}else{
					this.playVideo()
				}
			},
			replayVideo(){
				gsap.to(this.$refs.CTA,1,{autoAlpha:0})
				this.$refs.previewVid.currentTime=0;
				this.$refs.previewVid.volume=this.volume
				this.playVideo()
			},
			stopNcloseVideo(){
				this.$refs.previewVid.pause()
				this.closeVideo()
			},
			closeVideo(){
				this.enablePause=false
				this.videoShowing=false
				gsap.to(this.$refs.CTA,1,{autoAlpha:0})
				this.$store.commit("setCutScene",null)
				this.$refs.previewVid.currentTime=0;
				gsap.to(this,1,{projectorTop:-this.projectorHeight-400})
			},
			showWreckGui(wreckName){
				this.wreckName=wreckName
				this.$store.commit('setWreckByName',this.wreckName)
				this.showScreen()
			},
			objectClick(obj){
				if(!this.videoShowing){
					console.log("CLICKED OBJECTR",obj)
					this.wreckName=obj.name
					this.$store.commit('setWreckByName',this.wreckName)
					if(this.selectedWreck.sequence ){
						this.playVideo(this.getScenes(this.selectedWreck.sequence))
					}else if(this.selectedWreck.overview){
						if(this.unlockedScenes && this.unlockedScenes.length>0){
							this.playVideo(this.unlockedScenes.concat())
						}else{
							
							this.vidSrc=this.fireBaseWrecks+this.selectedWreck.overview
							this.playVideo(this.fireBaseWrecks+this.selectedWreck.overview)
						}
					}
					
				}
				
			},
			recordScene(scene){
				if(!this.unlockedScenes.includes(scene)){
					this.unlockedScenes.push(scene)	
					this.$store.dispatch('saveGameState')
				}
			},
			getScenes(sequence){
				let ns=[]
				let entry
				for (var i in sequence){
					entry=sequence[i].split(":")
					if(entry[1] && this.unlockedScenes.includes(entry[1])){
						ns.push(entry[1])
					}else if(entry[0]){
						ns.push(entry[0])
					}
					
				}
				return ns
			},
			showScreen(){
				console.log("ShowScreen",this.selectedWreck)
				gsap.killTweensOf(this.showHelp)
				this.screenVis=true
				gsap.fromTo(this.$refs.GUI,.3,{scaleY:.01},{scaleY:1,delay:1.5})
				gsap.fromTo(this.$refs.GUI,.1,{opacity:.1},{opacity:.9,repeat:20})
				gsap.fromTo(this.$refs.beams,.1,{opacity:.3},{opacity:.4,repeat:30})
				this.closeVideo()
				
				this.$store.commit('setWreckByName',this.wreckName)
				gsap.fromTo(this.$refs.beams,2,{scaleY:0},{scaleY:1})
				gsap.to(this,{duration:1,screenY:this.windowHeight,delay:.5})
				
				//help
				if(this.showIntro && !this.welcomePlayed){
					gsap.delayedCall(3,this.showHelp)
					this.welcomePlayed=true
					this.$store.commit("setShowIntro",false)
				}
				
				
			},
			closePanel(val){
				this.screenVis=false
				gsap.killTweensOf(this.$refs.beams)
				gsap.to(this.$refs.beams,.1,{opacity:0})
				gsap.to(this,1,{screenY:0})
				
			}
		},
		watch:{
			isUnavailable(val,old){
			
				if(!val){
					this.closePanel()
				}
			},
			gameStatus(val){
				if(val.activeWreck!=this.selectedWreck){
					//this.$store.commit('setWreckByName',val.activeWreck)
				
					console.log("GAME STATUS",this.gameStatus)
				}
				
			},
			selectedWreckId(val){
				this.gameStatus.activeWreck=val
				this.$store.dispatch('saveGameState')
				console.log("STATUS",this.gameStatus)
			},
			volume(val){
				if( this.$refs.previewVid){
					this.$refs.previewVid.volume=val
				}
				
			},
			cutScene(val){
				
				var hasPlayed=false
				console.log("CUT SCENE",val,hasPlayed)
				if(val){
					
					this.isCut=true
					var self=this
					var hasPlayed=false
					if(this.vidSrc==this.fireBaseWrecks+val){
						self.replayVideo()
					}else{

					this.recordScene(val)
					this.vidSrc=this.fireBaseWrecks+val
					//this.$refs.previewVid.addEventListener("canplay", this.replayVideo);
					if(!hasPlayed){
						this.$refs.previewVid.oncanplay  = function() {	
							if(!hasPlayed){
								self.replayVideo()
								hasPlayed=true
							}
						};
					}
					}
				
					
				}else{
					hasPlayed=false
					this.isCut=false
				}
				
			}
		},
		beforeDestroy(){
			if(this.selectedWreck )
				console.log("SET THE WRECK",this.selectedWreck)
				this.$store.commit('setCurrentMap',null)
			}
	};


	

</script>


<style>
body{
		overflow: hidden;
		-webkit-touch-callout: none;
		user-select: none; 
		-webkit-user-select: none; 
}
	.gui{
		position:absolute;
		top:0px;
		bottom:0px;
		width:100%;
		background-color:#0ff00f77;
		background: linear-gradient(#006677aa 1px, #000033aa 1px);
		background-size: 100% 5px;
		opacity:0.2;
	}
	.beams{
		pointer-events: none;
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		background-size: cover;
		opacity:0;
		background-image: url(/img/Glow.48148625.png);
		transform-origin:bottom;


	}
	.closeCut{
		color: #fff;
		position: absolute;
		height: 22px;
		padding: 7px;
		opacity: .7;
		left: 0px;
		width: 146px;
		border: #fff 1px solid;
		border-radius: 10px;
		right: 0px;
		top: 0px;
		bottom: 0px;
		margin: auto;
		cursor:pointer;
	}
	.closeCut:hover{
		opacity: .9;
	}
	.projector{
		position:absolute;
		top:0px;
		bottom:0px;
		left:0px;
		right:0px;
		width:100%;
		background-color:#000000dd;
		/*background: linear-gradient(#75818333 3px, #777777aa 1px);*/
		background-size: 100% 5px;
		margin:0px auto;
	}
	.wreckName{
		font-size:50px;
		color:#fff;
	}
	.CTA{
		position:absolute;
		visibility:hidden;
		opacity:0;
		width:100%;
		height:100%;
		top:0px;
		color:#fff;
		background-color: #000000aa;
	}
	.CTA h2{
		margin-top:20%
	}
	.CTA button{
		padding: 10px;
    margin: 10px;
    border-radius: 5px;
    font-family: "Orbitron";
	background-color:#ffffffaa;
	}
	.sceneBtn{
  color:#dbff00;
  cursor:pointer;
  border-radius:10px;
  border:dbff00 1px solid;
  box-shadow: 0px 0px 10px 0px, 0px 0px 10px 0px inset;
  width:240px;
  margin:auto;
  margin-top:20px;
  margin-bottom: 10px;
  text-align: center;
}
.sceneBtn:hover{
  box-shadow: 0px 0px 10px 6px, 0px 0px 10px 0px inset;
}
.vidMessage{
		color: #fff;
		position: absolute;
		padding-top:20px;
		font-size:15px;
		height: 1px;
		opacity: .5;
		left: 0px;
		right: 0px;
		top: 50px;
		bottom: 0px;
		margin: auto;
		
	}
</style>